/* Progressive enhancement only: menus and contact submission also work without JS. */
document.addEventListener('click', (event) => {
  const modeLink = event.target.closest('[data-tz-mode]');
  if (modeLink) {
    const field = document.querySelector('[data-tz-request-type]');
    if (field) field.value = modeLink.dataset.tzMode;
  }
  const menuLink = event.target.closest('.tz-mobile-panel a');
  if (menuLink) menuLink.closest('details').open = false;
  document.querySelectorAll('[data-tz-disclosure][open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-tz-disclosure][open]').forEach((details) => {
    const hadFocus = details.contains(document.activeElement);
    details.open = false;
    if (hadFocus) details.querySelector('summary').focus();
  });
});
